import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './services/auth/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'signin',
    pathMatch: 'full',
  },
  {
    path: 'signin',
    loadChildren: () => import('./common/common.module').then(m => m.CommonAppModule)
  },
  {
    path: 'hubAdmin',
    loadChildren: () => import('./hubadmin/hubadmin.module').then(m => m.HubadminModule)
  },
  {
    path: 'reward',
    loadChildren: () => import('./reward/reward.module').then(m => m.RewardModule)
  },
  {
    path: 'manager',
    loadChildren: () => import('./manager/manager.module').then(m => m.ManagerModule)
  },
  {
    path: 'agentPanel',
    loadChildren: () => import('./agentPanel/agent-panel.module').then(m => m.AgentPanelModule)
  },
  {
    path: 'call-center',
    loadChildren: () => import('./call-center/call-center.module').then(m => m.CallCenterModule)
  },
  {
    path: 'auditPanel',
    loadChildren: () => import('./auditpanel/auditpanel.module').then(m => m.AuditpanelModule)
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes,{
    useHash: true
 })
],
  exports: [RouterModule]
})
export class AppRoutingModule { }
